import React, { Fragment, useEffect, useState } from 'react';
import * as _ from 'lodash';
// import * as qs from 'qs';

import Header from '../components/Header';
import Popup from '../components/Popup';
import TierTable from '../components/TierTable';
import '../styles/_tiers.scss';

const AdminTiers = ({
  user,
  token,
  onLogout
}) => {
  const [showTier, setShowTier] = useState(false)
  const [adminTiers, setAdminTiers] = useState([])
  const [loadingTiers, setLoadingTiers] = useState(false)
  const [tierError, setTierError] = useState('')

  const [addTierError, setAddTierError] = useState('');
  const [loadingAddTier, setLoadingAddTier] = useState(false);
  const [newTier, setNewTier] = useState({
    name: '',
    description: '',
    cost: '',
    discountedCost: '',
    planId: ''
  })

  // useEffect(() => {
  //   if (!token) {
  //     setLoadingTiers(true)
  //   }
  // }, [])

  useEffect(() => {
    setLoadingTiers(true);
    if (token) {
      // have the token, get tiers from PayPal
      getAdminTiers()
      getAllMemberships()
    }
  }, [token])

  useEffect(() => {
    // admin tiers are pulled from PayPal, compare to DB values
    onCompareToDB()
  }, [adminTiers])

  useEffect(() => {
    if (!showTier) {
      // popup is being toggled closed
      setNewTier({
        name: '',
        description: '',
        cost: '',
        discountedCost: '',
        planId: ''
      });
      setLoadingAddTier(false);
    }
  }, [showTier])

  const onAddNewTier = async () => {
    if (!loadingAddTier) {
      // only if not already loading
      setLoadingAddTier(true)
      setAddTierError('')

      await addTierToPayPal(newTier)

      getAdminTiers() // this will trigger PayPal to DB comparisons, etc
    }
  }

  const [loading, setLoading] = useState(false)
  const [memberships, setMemberships] = useState([])
  const getAllMemberships = async () => {
    setLoading(true);

    const rawResponse = await fetch(`/api/subscriptions/active`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    console.log(rawResponse)
    const response = await rawResponse.json()
    console.log(response)
    if (response && response[0]) {
      const grouped = _.groupBy(response.filter(r => r.status === 'ACTIVE'), 'subscriptionTier.name')
      setMemberships(grouped)
    }
    
    setLoading(false)
  }

  // const onUpdateTier = async () => {
  //   if (!loadingAddTier) {
  //     setLoadingAddTier(true)
  //     setAddTierError('')

  //     await updateTierForPayPal(newTier)

  //     getAdminTiers()
  //   }
  // }

  const getAdminTiers = async () => {
    try {
      const rawResponse = await fetch(`https://api-m.paypal.com/v1/billing/plans/?page_size=20&page=1&sort_by=status`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const subResponse = await rawResponse.json();
      console.log(subResponse)

      let payPalPlans = [];
      for (const plan of subResponse.plans) {
        if (plan.status === 'ACTIVE') {
          const rawPlan = await fetch(`https://api-m.paypal.com/v1/billing/plans/${plan.id}`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          const p = await rawPlan.json();
          payPalPlans.push(p)
        }
      }

      payPalPlans = payPalPlans.map(p => {
        return {
          id: p.id,
          name: p.name,
          description: p.description,
          status: p.status,
          cost: p.billing_cycles[0].pricing_scheme.tiers[0].amount.value,
          discountedCost: p.billing_cycles[0].pricing_scheme.tiers[1].amount.value,
          isOff: p.status !== 'ACTIVE' ? true : false
        }
      })
      const sorted = payPalPlans.sort((a,b) => (+a.cost > +b.cost) ? 1 : ((+b.cost > +a.cost) ? -1 : 0)).filter(s => !s.isOff)
      setAdminTiers(sorted)
    } catch (error) {
      console.log(error)
    }
  }

  const onCompareToDB = async () => {
    try {
      const rawResponse = await fetch(`/api/tiers`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const tiersResponse = await rawResponse.json();

      // step 1 - compare to see if there are any new tiers that aren't in DB
      const tierPlanIds = tiersResponse.map(t => t.planId)
      adminTiers.forEach(t => {
        if (!tierPlanIds.includes(t.id)) {
          // PayPal returned a plan that we don't have
          const _tier = {
            name: t.name,
            description: t.description,
            cost: t.cost,
            discountedCost: t.discountedCost,
            planId: t.id,
            isOff: t.status === 'ACTIVE' ? false : true
          }
          addTierToDB(_tier)
        } else {
          // it exists!
          // step 2 - verify there weren't any changes
          const _dbTier = tiersResponse.find(tt => tt.planId === t.id)
          if (
            t.name !== _dbTier.name ||
            t.description !== _dbTier.description ||
            t.cost !== _dbTier.cost ||
            t.discountedCost !== _dbTier.discountedCost ||
            (t.status === 'ACTIVE' && _dbTier.isOff) ||
            (t.status !== 'ACTIVE' && !_dbTier.isOff)
          ) {
            const _tier = {
              id: _dbTier.id,
              name: t.name,
              description: t.description,
              cost: t.cost,
              discountedCost: t.discountedCost,
              planId: t.id,
              isOff: t.status === 'ACTIVE' ? false : true
            }

            updateTierInDB(_tier)
          }
        }
      });
    } catch (err) {
      console.log(err);
      setTierError(err);
    }

    setNewTier({
      name: '',
      description: '',
      cost: '',
      discountedCost: '',
      planId: ''
    });
    setLoadingAddTier(false);
    setShowTier(false);
    console.log('reset tiers')
    setLoadingTiers(false)
  }

  // helper - add tier to PayPal
  const addTierToPayPal = async (tier) => {
    // create a PayPal product
    let hasError = false
    let productId

    try {
      const productResponse = await fetch(`https://api-m.paypal.com/v1/catalogs/products`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'name': tier.name,
          'description': tier.description,
          'type': 'SERVICE',
          'category': 'AUTO_SERVICE'
        })
      });

      const product = await productResponse.json()
      productId = product.id
      console.log(product)
    } catch (err) {
      hasError = true
      setTierError('There was a problem creating a product in PayPal.')
      return err
    }
    
    if (!hasError && productId) {
      // created the product successfully
      // create a plan using product ID
      try {
        const planResponse = await fetch(`https://api-m.paypal.com/v1/billing/plans`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              product_id: productId,
              name: tier.name,
              status: 'ACTIVE',
              description: tier.description,
              billing_cycles: [{
                pricing_scheme: {
                  version: 1,
                  // fixed_price: 
                  pricing_model: 'TIERED',
                  tiers: [
                    {
                      starting_quantity: '1',
                      ending_quantity: '1',
                      amount: {
                        currency_code: 'USD',
                        value: tier.cost
                      }
                    },
                    {
                      starting_quantity: '2',
                      amount: {
                        currency_code: 'USD',
                        value: tier.discountedCost
                      }
                    }
                  ],
                  create_time: new Date(),
                  update_time: new Date()
                },
                frequency: {
                  interval_unit: 'MONTH',
                  interval_count: 1
                },
                tenure_type: 'REGULAR', // or TRIAL
                sequence: 1,
                total_cycles: 0 // infinite
              }],
              payment_preferences: {
                auto_bill_outstanding: true,
                setup_fee: {
                  currency_code: 'USD',
                  value: '0.00'
                },
                setup_fee_failure_action: 'CONTINUE',
                payment_failure_threshold: 2
              },
              taxes: {
                percentage: '6',
                inclusive: false
              },
              quantity_supported: true
            })
          });

        const plan = await planResponse.json()
        console.log(plan)
        return plan
      } catch (err) {
        setTierError('There was a problem creating a plan in PayPal.')
        return err
      }
    }

    setLoadingAddTier(false)
  }

  // const onActivatePlan = async (tierId) => {
  //   setLoadingTiers(true)

  //   try {
  //     await fetch(`https://api-m.paypal.com/v1/billing/plans/${tierId}/activate`, {
  //       method: 'POST',
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         'Content-Type': 'application/json'
  //       }
  //     });

  //     getAdminTiers()
  //   } catch (err) {
  //     console.log(err)
  //     setTierError('There was a problem updating this plan in PayPal.')
  //     return err
  //   }

  //   // setLoadingTiers(false)
  // }

  // const [showEnableDisable, setShowEnableDisable] = useState(false);
  // const onConfirmDisable = (tierId) => {
  //   console.log(tierId)
  //   setNewTier({...newTier, planId: tierId})
  //   setShowEnableDisable(true);
  // }

  // const onDeactivatePlan = async () => {
  //   setLoadingTiers(true)

  //   try {
  //     await fetch(`https://api-m.paypal.com/v1/billing/plans/${newTier.planId}/deactivate`, {
  //       method: 'POST',
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         'Content-Type': 'application/json'
  //       }
  //     });

  //     setNewTier({
  //       name: '',
  //       description: '',
  //       cost: '',
  //       discountedCost: '',
  //       planId: ''
  //     });
  //     setShowEnableDisable(false)

  //     getAdminTiers()
  //   } catch (err) {
  //     console.log(err)
  //     setTierError('There was a problem updating this plan in PayPal.')
  //     return err
  //   }

  //   // setLoadingTiers(false)
  // }

  // helper - add tier to DB
  const addTierToDB = async (tier) => {
    try {
      const rawResponse = await fetch(`/api/tiers`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ tier })
      });

      const response =  await rawResponse.json();
      if (response.error) {
        setLoadingAddTier(false);
        setAddTierError(response.error);
      } else {
        setNewTier({
          name: '',
          description: '',
          cost: '',
          discountedCost: '',
          planId: ''
        });
        setLoadingAddTier(false);
        setShowTier(false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  // helper - update tier in DB
  const updateTierInDB = async (tier) => {
    try {
      const rawResponse = await fetch(`/api/tiers/${tier.id}`, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ tier })
      });

      return await rawResponse.json()
    } catch (error) {
      console.log(error);
    }
  }

  const onChangeTier = (e) => {
    if (e.target.name === 'cost' || e.target.name === 'discountedCost') {
      const cost = e.target.value.replace(/\./g, '');

      // cost parsing
      if (cost.length > 2) {
        const ones = cost[cost.length - 1];
        const tens = cost[cost.length - 2];

        e.target.value = cost.slice(0, -2) + `.${tens}${ones}`;
      } else {
        e.target.value = cost;
      }
    }

    // limit description to 150 characters
    if (e.target.name === 'description') {
      if (e.target.value.length <= 150) {
        setNewTier({
          ...newTier,
          description: e.target.value
        })
      }
    } else {
      setNewTier({
        ...newTier,
        [e.target.name]: e.target.value
      })
    }
  }

  // const onEnableTier = (tierId) => {
  //   const tier = adminTiers.find(t => t.id === tierId);
  //   tier.isOff = false;
  //   setNewTier(tier);

  //   onUpdateTier();
  //   setShowEnableDisable(false);
  // }

  // const onDisableTier = (tierId) => {
  //   const tier = adminTiers.find(t => t.id === tierId);
  //   setNewTier(tier);
  //   setShowEnableDisable(true);
  // }

  const {name, description, cost, discountedCost} = newTier;

  return (
    <>
      <Header user={user} onLogout={onLogout}></Header>
      <div className="admin-tiers">
        <div className="admin-content">
          <h1>Membership Subscription Tiers</h1>
          <div>As an admin, you are able to view and manage membership subscription tiers in the Quik Quality Portal.</div>
          <div>These are the same memberships users see when registering their vehicles.</div>
          <div>Revisions made in your PayPal admin portal will not appear here, only new tiers will be added (e.g. changing a description in PayPal will not update it here).</div>
          <div>Do not disable / turn off a tier without notifying all members they need to cancel their subscriptions.</div>

          <div className="table-note">
            {/* <div>Membership subscriptions <b>must</b> include a <b>Plan ID</b> from an <b>active</b> PayPal subscription. View subscription Plan IDs but clicking the  <i className="fa fa-pencil"></i> icon.</div> */}
            {/* <div>You can turn a subscription tier off by clicking the <i className="fa fa-toggle-on" style={{color: '#04b840'}}></i> icon. Doing so will permanently remove the tier from your list and deactivate any linked user memberships.</div> */}
            {/* <div>Making changes to this dashboard <b>does not</b> update your PayPal dashboard.</div> */}
          </div>
          
          <TierTable
            tiers={adminTiers}
            loading={loadingTiers || loading}
            memberships={memberships}
            dataError={tierError}
            // onEditTier={onEditTier}
            // onEnableTier={onActivatePlan}
            // onDisableTier={onConfirmDisable}
          >
          </TierTable>
          <a href="https://www.paypal.com/billing/plans" target="_blank" rel="noreferrer">
            <div className="btn primary" /*onClick={() => setShowTier(true)}*/>+ Add Membership Tier</div>
          </a>
        </div>

        <Popup
          showPopup={showTier}
          loading={loadingAddTier}
          setShowPopup={setShowTier}
          user={user}
          title={'Add Membership Subscription Tier'}
          buttonTitle={'Add'}
          buttonAction={onAddNewTier}
          error={addTierError}
        >
          <p className="popup-description">These are the subscriptions users can select when they create a membership.</p>
          <p className="popup-description">Subscriptions are tiered - after one vehicle is registered, every additional vehicle is discounted.</p>
          <p className="popup-description" style={{marginBottom: '2rem'}}><b>This information cannot be changed/edited.</b></p>
          <input type="text" placeholder="enter tier name" name="name" value={name} disabled={!!newTier.id} onChange={(e) => onChangeTier(e)} />
          <textarea name="description" rows="3" cols="50" value={description} placeholder="enter description" onChange={(e) => onChangeTier(e)}></textarea>
          {/* <input type="text" placeholder="enter PayPal Plan ID" name="planId" value={planId} onChange={(e) => onChangeTier(e)} /> */}
          <div className="dollar-input">
            <b>$</b>
            <input type="text" placeholder="enter cost" name="cost" value={cost} onChange={(e) => onChangeTier(e)} />
          </div>
          <div className="dollar-input">
            <b>$</b>
            <input type="text" placeholder="enter discounted cost" name="discountedCost" value={discountedCost} onChange={(e) => onChangeTier(e)}/>
          </div>
          {/* {newTier.id &&
            <label class="container">Notify Subscribers of Change
              <input type="checkbox" checked="checked"/>
              <span class="checkmark"></span>
            </label>
          } */}
        </Popup>

        {/* <Popup
          showPopup={showEnableDisable}
          loading={loadingAddTier}
          setShowPopup={setShowEnableDisable}
          user={user}
          title={!newTier.isOff ? 'Disable Tier' : 'Enable Tier'}
          buttonTitle={!newTier.isOff ? 'Disable' : 'Enable'}
          buttonAction={onDeactivatePlan}
          error={addTierError}
        >
          <p className="popup-description" style={{marginTop: 0}}><b>{newTier.name}</b></p>
          <p className="popup-description">You are attempting to turn this membership subscription off. This means that users will not be able to sign up for this membership, and the plan will be deactivated for existing users.</p>
          <p className="popup-description" style={{marginBottom: '2rem'}}><b>This action cannot be undone.</b></p>

          <label class="container">Notify Subscribers of Change
            <input type="checkbox" checked="checked"/>
            <span class="checkmark"></span>
          </label>
        </Popup> */}
      </div>
    </>
  )

}

export default AdminTiers;